import { getCardPayout } from "@api";
import {
  Drawer,
  DrawerBody,
  GridSection,
  GridSectionBody,
  Badge,
  GridSectionHeader,
  GridSectionItem,
  GridSectionSpan,
} from "@components";
import { formatAmount, formatDateTime } from "@utils";
import { useEffect, useState } from "react";
import { payoutStatusColors } from "../common";
import { TransactionDetails } from "@areas";
import PayoutTransactions from "../components/PayoutTransactions";

const PayoutDetails = ({ id, onClose }) => {
  const [payout, setPayout] = useState(null);
  const [selectedPayoutTransaction, setSelectedPayoutTransaction] =
    useState(null);

  const reloadData = async () => {
    const data = await getCardPayout(id);
    setPayout(data);
  };

  useEffect(() => {
    if (id) {
      reloadData();
    }
  }, [id]);

  return (
    <Drawer title="Payout details" isOpen={!!id} size="lg" toggle={onClose}>
      {payout && (
        <>
          <DrawerBody>
            <GridSection>
              <GridSectionSpan>
                <h2 className="text-3xl font-medium m-0 mr-2">
                  {formatAmount(payout.amount)}
                </h2>
                <Badge color={payoutStatusColors[payout.status]}>
                  {payout.status}
                </Badge>
              </GridSectionSpan>
            </GridSection>
            <GridSection>
              <GridSectionItem>
                <GridSectionHeader>Settlement date</GridSectionHeader>
                <GridSectionBody>
                  {formatDateTime(payout.arrivalDate)}
                </GridSectionBody>
              </GridSectionItem>
            </GridSection>
            <GridSection>
              <PayoutTransactions
                transactions={payout.transactions}
                onTransactionClick={(x) => setSelectedPayoutTransaction(x)}
              />
            </GridSection>
          </DrawerBody>
        </>
      )}
      {/* A row opens the payment it settles. The row's own id is not always that payment: a
          payment split across balance accounts is one row per share, keyed by the share. A refund
          row with no original payment is an unreferenced POS refund: it opens as a refund in its
          own right rather than through a payment. */}
      <TransactionDetails
        onClose={() => setSelectedPayoutTransaction(null)}
        id={
          selectedPayoutTransaction &&
          (selectedPayoutTransaction.originalPaymentId ??
            selectedPayoutTransaction.paymentId ??
            null)
        }
        transactionType={
          selectedPayoutTransaction &&
          selectedPayoutTransaction.type === "CardRefund" &&
          !selectedPayoutTransaction.originalPaymentId
            ? "Refund"
            : undefined
        }
        refundId={
          selectedPayoutTransaction &&
          selectedPayoutTransaction.type === "CardRefund" &&
          !selectedPayoutTransaction.originalPaymentId
            ? selectedPayoutTransaction.id
            : undefined
        }
        paymentMethodKey={
          selectedPayoutTransaction?.type?.includes("Card")
            ? "card"
            : selectedPayoutTransaction?.type?.includes("ThirdParty")
              ? "klarna"
              : ""
        }
        onChange={() => reloadData()}
      />
    </Drawer>
  );
};

export default PayoutDetails;
